module.exports = __webpack_public_path__ + "img/login-img.ab1a2caa.webp";